export const ASTERISK = '*';
//# sourceMappingURL=htmlConstants.js.map